import request from '@/utils/request'

// getAutSaveYN
export function getAutSaveYN(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getAutSaveYN`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getAutInspection
export function getAutInspection(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getAutInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getInsResultChk
export function getInsResultChk(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getInsResultChk`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getInsResultChkDel
export function getInsResultChkDel(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getInsResultChkDel`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getShipIncharge
export function getShipIncharge(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getShipIncharge`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getCloseYN
export function getCloseYN(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getCloseYN`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getEvalPoint
export function getEvalPoint(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/getEvalPoint`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80b1020List
export function v80b1020List(param) {
    let data = param
    return request({
      url: `/v80/v80b1020/v80b1020List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

// v80b1020Update
export function v80b1020Update(param) {
  let data = param
  return request({
    url: `/v80/v80b1020/v80b1020Update`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}